import image1 from '@/assets/images/news/detail/20210108/1.png';
import image2 from '@/assets/images/news/detail/20210108/2.jpg';
import image3 from '@/assets/images/news/detail/20210108/3.jpg';
import image4 from '@/assets/images/news/detail/20210108/4.jpg';
import image5 from '@/assets/images/news/detail/20210108/5.png';

export default {
  id: '20210108', //  模块 id
  title: '2021叮咚买菜年度品牌沙龙成功举行', // 标题
  origin: '', // 新闻来源
  editor: '', // 编辑者
  content: [
    {
      type: 1,
      title: '',
      src: [image1],
    },
    {
      type: 0,
      text:
        '2021年1月8日，叮咚买菜年度品牌沙龙在叮咚买菜上海总部圆满落幕。会议通过对叮咚买菜的介绍、叮咚买菜营销图鉴的介绍、现场案例分享、营销规划宣讲，回顾了过去一年的品牌营销合作，并对现在的叮咚买菜营销模式进行了介绍，展望了2021年未来的规划。',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '梁昌霖在会议上分享了叮咚买菜的商业逻辑与认知，解释了在种子论的支持下，叮咚如何通过“三大思考思维”、“7+1品控流程”促进叮咚买菜成为用户信任、复购率高、复制能力强、发展潜力大的生鲜平台。',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image2],
    },
    {
      type: 1,
      title: '',
      src: [image3],
    },
    {
      type: 0,
      text:
        '沙龙期间，用户运营中心负责人熊卫还对买菜行业的营销趋势进行了解读。在生鲜生态供应链升级的趋势下，指出2021年叮咚买菜能够成为“标品+生鲜=1+1>2”这一新的营销趋势的最佳落地平台，并对叮咚买菜平台的营销图谱进行了解读。采销中心负责人徐志坚也对这一营销趋势下，基于商品维度的前提下，品牌合作如何达成品效合一，提供了关于商品层面的独到见解，叮咚坚持基地和联采，将提供给更多用户更多的信心。',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '本次沙龙还颁布了“2020年度叮咚买菜年度四十佳合作品牌”、“金色麦穗最佳营销案例奖”、“金色麦穗最受认可品牌奖”、“金色麦穗最佳人气单品奖”。分别从营销案例、品牌维度、商品维度等综合选出了表现突出的品牌，这些品牌在过去一年与叮咚的合作中，通过站内曝光与站外投放的联合，品牌与平台的联动，完成了业绩的增长。',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image4],
    },
    {
      type: 0,
      text:
        '颁奖后，市场部罗丽媛也正式宣讲了2021年叮咚买菜品牌营销合作规划，明确了合作节点与合作流程，也让在场的各位嘉宾对新一年的合作有更清晰的计划和更大的合作空间。',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image5],
    },
    {
      type: 0,
      text:
        '叮咚买菜的愿景是让美好的食材像自来水一样，触手可得，普惠万众。在目前众多赛道和各种买菜的模式的竞争下，叮咚买菜会始终保持初心，志在为用户提供更好的服务。',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '特别鸣谢：采销中心、行政效能部、运维部对本次年度品牌沙龙活动的支持',
      isIndent: false,
    },
  ],
};
